import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateEtlPackageExecution {
        __typename
        id
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackageExecutions/NewSubscription.js